// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"532":"styles","678":"component---src-pages-index-js","883":"component---src-pages-404-js"}[chunkId] + "-" + {"532":"4fffce1ecfea467ce4da","678":"ffb4910559b97f54d117","883":"181b3d6d54be6bef7e16"}[chunkId] + ".js";
};